module.exports = __webpack_public_path__ + "assets/img/brand-03.3c22f8c5.png";